<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Appraisal Sub Parameter and Appraisal Level
            Linking</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year"
              @change="getAySelfParameter()" />
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="self_appriasal_parameter_list != ''">
            <p><v-icon color="error">*</v-icon><b>Apprisal Parameter</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="selfAppraisalParameter"
              :items="self_appriasal_parameter_list" item-text="parameter_name" item-value="id"
              label="Apprisal Parameter" outlined persistent-hint hint="Please Select Apprisal Parameter"
              @change="getSubSelfParameter()" />
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="self_appriasal_sub_parameter_list != ''">
            <p><v-icon color="error">*</v-icon><b>Apprisal Sub Parameter</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="selfAppraisalSubParameter"
              :items="self_appriasal_sub_parameter_list" item-text="parameter_name" item-value="id"
              label="Apprisal Sub Parameter" outlined persistent-hint hint="Please Select Apprisal Sub Parameter" />
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="selfAppraisalSubParameter && apprisal_level_list != ''">
          <v-col class="box" cols="12" sm="3" md="3" v-for="level in apprisal_level_list" :key="level.id">
            <v-col cols="12" sm="12" md="12">
              <v-row justify="center" dense>
                <strong> {{ level.name }}</strong>
              </v-row>
              <v-row justify="center" dense>
                <v-text-field label="Level Marks" rounded type="number" outlined dense
                  v-model="level.marks"></v-text-field>
              </v-row>
              <v-row justify="center" dense>
                <v-textarea outlined name="input-7-4" rounded dense v-model="level.description"
                  label="Enter Description"></v-textarea>
              </v-row>
            </v-col>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="selfAppraisalSubParameter">
          <v-btn class="button" @click="savesubParameterApprisalLevelLinking()">Save</v-btn>
        </v-row>
      </v-card>
      <v-card class="box" v-if="self_apprisal_level_linking_list != ''">
        <v-toolbar dense flat class="toolbar">
          <v-toolbar-title>Appraisal Sub Parameter and Appraisal Level
            Linking</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br />
        <v-data-table v-if="self_apprisal_level_linking_list != ''" dense class="elevation-1 mytable" :headers="headers"
          :items="bookList1" fixed-header>
          <template v-slot:top class="pb-5">
            <v-row justify="center" align="center">
              <tr class="t-row">
                <div>
                  <th>
                    <v-row>
                      <span v-for="header in headers" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                            color="#0F2027" :label="header.text" multiple clearable
                            :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                        </span>
                      </span>
                    </v-row>
                  </th>
                </div>
              </tr>
            </v-row>
          </template>
          <!-- shiv description added -->
          <!-- <template v-slot:[`item.desc`]="{ item }">
            <span class="viewdesc" @click="viewDescription(item)">
              {{ item.description.slice(0, 30) }}...
            </span>
          </template> -->

          <template v-slot:[`item.desc`]="{ item }">
            <v-tooltip top max-width="80%" color="orange">
              <template v-slot:activator="{ on, attrs }">
                <span class="viewdesc" v-bind="attrs" v-on="on">
                  {{ item.description.slice(0, 20) }}...
                </span>
              </template>
              <span style="font-weight: bold">
                {{ item.description }}
              </span>
            </v-tooltip>
          </template>

          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-5" v-bind="attrs" v-on="on" color="red"
                >mdi-information</v-icon
              >
            </template>
            <span>
              {{ aspl.as_al_description }}
            </span>
          </v-tooltip> -->
          <!-- code end -->
          <template v-slot:[`item.isactive`]="{ item }">
            <span v-if="item.isactive">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <div>
              <v-avatar style="" size="25" class="edit-avatar" @click="editItem(item)">
                <v-icon class="edit-v-icon mr-2">edit</v-icon>
              </v-avatar>
            </div>
          </template>
          <template v-slot:[`item.toggle`]="{ item }">
            <v-switch v-model="item.isactive" @change="saveActiveStatusLevelLinking(item)"></v-switch>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog_edit" persistent scrollable="false" max-width="1200px"
      transition="dialog-bottom-transition">
      <v-card>
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Appraisal Sub Parameter and Appraisal Level
              Linking</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3" md="3">
                <p><b>Academic Year</b></p>
                <v-text-field rounded readonly filled outlined dense v-model="editedItem.academicyear"></v-text-field>
                <!-- <v-autocomplete dense rounded outlined :items="ay_list" item-text="ay" v-model="editedItem.academicyear" label="Academic Year *" placeholder="Select Academic Year"></v-autocomplete> -->
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <p><b>Apprisal Sub Parameter</b></p>
                <v-text-field rounded readonly filled outlined dense
                  v-model="editedItem.selfappraisalsubParameter"></v-text-field>
                <!-- <v-autocomplete color="#0F2027" dense rounded required v-model="editedItem.selfAppraisalSubParameter" :items="self_appriasal_sub_parameter_list" item-text="parameter_name" label="Apprisal Sub Parameter" outlined persistent-hint hint="Please Select Apprisal Sub Parameter" />-->
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <p><b>Apprisal Level</b></p>
                <v-text-field rounded readonly filled outlined dense v-model="editedItem.appraisallevel"></v-text-field>
                <!-- <v-autocomplete color="#0F2027" dense rounded required v-model="editedItem.appraisallevel" :items="apprisal_level_list" item-text="name" return-object label="Apprisal Level" outlined persistent-hint hint="Please Select Apprisal Level" /> -->
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <p><b>Marks</b></p>
                <v-text-field rounded type="number" outlined dense v-model="editedItem.marks"></v-text-field>
              </v-col>
              <v-col cols="12" md="9" sm="9">
                <p><b>Description</b></p>
                <v-textarea outlined name="input-7-4" dense v-model="editedItem.description"
                  label="Enter Description"></v-textarea>
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <p><b>Isactive</b></p>
                <v-switch v-model="editedItem.isactive"></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn class="button" :loading="loader" @click="editsubParameterApprisalLevelLinking()">Update</v-btn>
            <v-btn class="button" @click="dialog_edit = false">Close</v-btn>
          </v-row>
        </v-card>
      </v-card>
    </v-dialog>

    <!-- description dialog -->
    <v-dialog class="dialogview" v-model="dialog_view" persistent max-width="500px"
      transition="dialog-bottom-transition">
      <v-card class="box1">
        <br />
        <center>
          <span style="font-size: 15px">
            <b> {{ viewdescription }} </b>
          </span>
        </center>
        <!-- <br /> -->
        <v-row justify="center">
          <v-col cols="12" sm="4" md="4">
            <v-btn class="button" @click="dialog_view = false">Close</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    // extraBreadcrumbItems: [
    //   { text: "Sub Parameter And Level", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    snackbar: false,
    overlay: false,
    criteria: "",
    ay_list: [],
    ay: "",
    apprisal_level_list: [],
    self_appriasal_parameter_list: [],
    selfAppraisalParameter: null,
    self_appriasal_sub_parameter_list: [],
    selfAppraisalSubParameter: null,
    dialog_edit: false,
    dialog_view: false,
    self_apprisal_level_linking_list: [],
    headers: [
      { text: "Sr No", value: "count" },
      { text: "Academic Year", value: "academicyear" },
      { text: "Appraisal Level", value: "appraisallevel" },
      { text: "Appraisal Parameter", value: "selfappraisalParameter" },

      { text: "Appraisal Sub Parameter", value: "selfappraisalsubParameter" },
      { text: "Marks", value: "marks" },
      { text: "Description", value: "desc" },
      //   { text: "Description", value: "description" },

      { text: "Active", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Mark Active/Inactive", value: "toggle" },
    ],
    filters: {
      academicyear: [],
      selfappraisalParameter: [],
      selfappraisalsubParameter: [],
      appraisallevel: [],
    },
    editedItem: {
      academicyear: null,
      appraisallevel: null,
      selfappraisalsubParameter: null,
      marks: null,
      description: null,
      isactive: null,
      id: null,
      viewdescription: null,
    },
  }),
  methods: {
    columnValueList(val) {
      return this.self_apprisal_level_linking_list.map((d) => d[val]);
    },
    viewDescription(item) {
      console.log(item);
      this.viewdescription = item.description;
      this.dialog_view = true;
    },
    editItem(item) {
      (this.editedItem.academicyear = item.academicyear),
        (this.editedItem.appraisallevel = item.appraisallevel),
        (this.editedItem.selfappraisalsubParameter =
          item.selfappraisalsubParameter),
        (this.editedItem.marks = item.marks),
        (this.editedItem.description = item.description),
        (this.editedItem.isactive = item.isactive);
      this.editedItem.id = item.id;
      this.dialog_edit = true;
    },
    editsubParameterApprisalLevelLinking() {
      this.overlay = true;
      axios
        .post(
          "/SelfAppriasalMaster/editsubParameterApprisalLevelLinking",
          this.editedItem
        )
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Updated Successfully...");
            this.onLoad();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
          this.dialog_edit = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    saveActiveStatusLevelLinking(item) {
      this.overlay = true;
      axios
        .post("/SelfAppriasalMaster/saveActiveStatusLevelLinking", item)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Updated Successfully...");
            this.onLoad();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },

    savesubParameterApprisalLevelLinking() {
      if(this.apprisal_level_list == ''){
        this.showSnackbar("error", "Appraisal level not found for selected AY...");
        return;
      }
      const data = {
        ay: this.ay,
        selfAppraisalSubParameter: this.selfAppraisalSubParameter,
        apprisal_level_list: this.apprisal_level_list,
      };
      this.overlay = true;
      axios
        .post("/SelfAppriasalMaster/savesubParameterApprisalLevelLinking", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Added Successfully...");
            this.onLoad();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.apprisal_level_list = [];
          this.self_appriasal_sub_parameter_list = [];
          this.selfAppraisalSubParameter = null;
          this.selfAppraisalParameter = null;
          this.self_appriasal_parameter_list = [];
          this.ay = null;
        });
    },
    getAySelfParameter() {
      const data = {
        ay: this.ay,
      };
      this.overlay = true;
      axios
        .post("/SelfAppriasalMaster/getAySelfParameter", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.self_appriasal_parameter_list =
              res.data.self_appriasal_parameter_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getSubSelfParameter() {
      const data = {
        ay: this.ay,
        selfAppraisalParameter: this.selfAppraisalParameter,
      };
      this.overlay = true;
      axios
        .post("/SelfAppriasalMaster/getSubSelfParameter", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.self_appriasal_sub_parameter_list =
              res.data.self_appriasal_sub_parameter_list;
            this.apprisal_level_list = res.data.apprisal_level_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    onLoad() {
      axios
        .post("SelfAppriasalMaster/apprisalLevelLinkingHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.ay_list = res.data.ay_list;
            this.self_apprisal_level_linking_list =
              res.data.self_apprisal_level_linking_list;
            this.overlay = false;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
  computed: {
    bookList1() {
      return this.self_apprisal_level_linking_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.dialogview {
  overflow: hidden;
}
.box1 {
  width: 100%;
  overflow: hidden;
  border: 2px solid #8360c3;
}
.viewdesc {
  cursor: pointer;
}
</style>

